const readMoreContent = document.querySelectorAll(".mb-readmore");

const readMoreExpandLabel = "weiter lesen";
const readMoreCompressLabel = "weniger lesen";

const maxHeightCompressed = 370;

export function initReadmore() {
  for (let i = 0; i < readMoreContent.length; i++) {
    // Wrap content
    const innnerHTML = readMoreContent[i].innerHTML;
    const contentWrapper = document.createElement("div");
    contentWrapper.classList.add("mb-readmore-wrapper");
    contentWrapper.innerHTML = innnerHTML;
    readMoreContent[i].innerHTML = "";
    readMoreContent[i].appendChild(contentWrapper);

    // Create label
    const readMoreLabel = document.createElement("span");
    readMoreLabel.classList.add("mb-readmore-toggle");
    readMoreLabel.innerHTML = readMoreExpandLabel;
    readMoreContent[i].appendChild(readMoreLabel);

    // Add click listener
    readMoreLabel.addEventListener("click", (e) => {
      readMoreContent[i].classList.toggle("mb-readmore-expanded");

      if (readMoreContent[i].classList.contains("mb-readmore-expanded")) {
        readMoreLabel.innerHTML = readMoreCompressLabel;
        console.log(contentWrapper.offsetHeight);
        readMoreContent[i].style.maxHeight =
          contentWrapper.offsetHeight + 50 + "px";
      } else {
        readMoreLabel.innerHTML = readMoreExpandLabel;
        readMoreContent[i].style.cssText = "";
      }
    });
  }

  updateReadMore();
}

export function updateReadMore() {
  for (let i = 0; i < readMoreContent.length; i++) {
    const contentWrapper = readMoreContent[i].querySelector(
      ".mb-readmore-wrapper"
    );

    // check total height
    if (contentWrapper.offsetHeight > maxHeightCompressed) {
      readMoreContent[i].classList.add("mb-readmore-active");
    } else {
      readMoreContent[i].classList.remove("mb-readmore-active");
    }
  }
}
